import { Link, useParams } from "wouter";
import { List, Article, PlugsConnected } from "@phosphor-icons/react";
import { overviewRegistry } from "../overview_registry.js";

function BrowseContent() {
  const { orgSlug } = useParams<{ orgSlug: string }>();

  const links = [
    { href: `/o/${orgSlug}/i`, label: "All Items", icon: List },
    { href: `/o/${orgSlug}/p`, label: "All Posts", icon: Article },
    {
      href: `/o/${orgSlug}/n`,
      label: "All Integrations",
      icon: PlugsConnected,
    },
  ];

  return (
    <ul className="space-y-2">
      {links.map(({ href, label, icon: Icon }) => (
        <li key={href}>
          <Link
            href={href}
            className="flex items-center gap-2 text-sm hover:underline"
          >
            <Icon size={16} className="text-muted-foreground" />
            {label}
          </Link>
        </li>
      ))}
    </ul>
  );
}

overviewRegistry.register({
  type: "browse",
  order: 10,
  title: "Browse",
  content: BrowseContent,
});
